import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function StorySection() {
  return (
    <section id="story" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Left: Image */}
          <ScrollReveal className="order-first">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Textile%20engineers%20and%20workers%20collaborating%20in%20a%20modern%20Bangladesh%20garment%20factory%2C%20warm%20natural%20lighting%2C%20diverse%20professional%20team%20inspecting%20fabric%20quality%20together%2C%20warm%20cream%20beige%20and%20earth%20tones%2C%20professional%20corporate%20documentary%20photography%2C%20no%20blue%20no%20purple%20colors%2C%20clean%20industrial%20environment&width=600&height=750&seq=about-story-1&orientation=portrait"
                alt="TIE team collaborating in a textile facility"
                className="w-full h-[320px] md:h-[480px] lg:h-[560px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-tie-navy/30 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white/90 backdrop-blur-sm">
                  <span className="w-2 h-2 rounded-full bg-tie-teal" />
                  <span className="text-xs font-medium text-tie-text-primary">
                    Dhaka, Bangladesh
                  </span>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* Right: Content */}
          <div>
            <ScrollReveal delay={100}>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Our Story
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-snug">
                Born From Factory Floors, Built for Global Competitiveness
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <div className="mt-5 md:mt-6 space-y-4 text-sm md:text-base text-tie-text-secondary leading-relaxed">
                <p>
                  Textile Innovation Exchange (TIE) was founded in response to a
                  critical gap in Bangladesh's ready-made garment sector: the
                  absence of a unified, institutional mechanism to identify,
                  implement, and scale innovation across factories.
                </p>
                <p>
                  For decades, individual factories, buying houses, and
                  technology providers had pursued improvement in silos. Some
                  invested in new machinery without measurable ROI. Others ran
                  pilot projects that never scaled. Researchers published papers
                  that never reached factory managers. The result was fragmented
                  progress - and a sector still perceived as cost-competitive
                  rather than innovation-competitive.
                </p>
                <p>
                  TIE was created to change that. By bringing together
                  Bangladesh Knitwear Manufacturers and Exporters Association
                  (BKMEA) and Bangladesh Garment Buying House Association
                  (BGBA) as founding association partners, TIE established a
                  neutral, credible platform with the authority and network to
                  drive sector-wide transformation.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="mt-6 md:mt-8 p-5 md:p-6 rounded-xl bg-tie-navy-soft border border-tie-grey-dark">
                <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed italic">
                  "The question is not whether innovation will happen - it is
                  whether innovation will be systematic, measurable, and
                  sustainable. TIE exists to ensure the answer is yes."
                </p>
                <p className="mt-3 text-xs font-semibold text-tie-text-muted uppercase tracking-wider">
                  - TIE Steering Board
                </p>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}